<template>
  <div class="wrapper">
    <survey-page-title
      :title="value.displayName"
      :description="value.description"
      :pageIndex="pageIndex"
      :pageCount="pageCount"
    ></survey-page-title>
    <div class="clickLayer text-right rounded" @click.stop="edit">
      <div
        class="mt-3 mr-3 primary rounded elevation-3 overflow-hidden d-inline-block"
      >
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              class="white--text"
              tile
              icon
              @click.stop="edit"
            >
              <v-icon small>$edit</v-icon>
            </v-btn>
          </template>
          <span>Edit Page Title</span>
        </v-tooltip>
      </div>
    </div>

    <v-dialog v-model="openEditor" max-width="600">
      <ValidationObserver ref="observer" tag="form" @submit.prevent="onSubmit">
        <v-card>
          <dialog-title
            v-model="openEditor"
            title="Edit Page Title"
          ></dialog-title>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                Fill out the form below to change the survey title.
              </v-col>
              <v-col cols="12">
                <ValidationProvider
                  rules="required|min:2|max:500"
                  v-slot="{ errors }"
                  vid="title"
                >
                  <v-text-field
                    label="Title*"
                    v-model="innerValue.displayName"
                    outlined
                    :error-messages="errors"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
              <v-col cols="12">
                <ValidationProvider
                  rules="min:2|max:2000"
                  v-slot="{ errors }"
                  vid="title"
                >
                  <v-textarea
                    label="Description"
                    v-model="innerValue.description"
                    outlined
                    :error-messages="errors"
                    rows="3"
                  ></v-textarea>
                </ValidationProvider>
              </v-col>
              <v-col cols="12">
                <ValidationProvider
                  rules="required|min:2|max:500"
                  v-slot="{ errors }"
                  vid="key"
                >
                  <v-text-field
                    label="Key*"
                    v-model="innerValue.key"
                    outlined
                    :error-messages="errors"
                    persistent-hint
                    hint=""
                    :disabled="locked"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
              <v-col cols="12" class="d-flex align-center">
                <small class="flex-fill">*indicates required field</small>
                <v-btn text color="primary" @click="openEditor = false">
                  Cancel
                </v-btn>
                <v-btn v-if="!locked" type="submit" color="primary">
                  Ok
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </ValidationObserver>
    </v-dialog>
  </div>
</template>

<style scoped lang="scss">
.wrapper {
  position: relative;
  z-index: 0;

  .clickLayer {
    opacity: 0;
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.15);
    transition: opacity 300ms ease-in-out;
    cursor: pointer;

    &:hover {
      opacity: 1;
    }
  }
}
</style>

<script>
import DialogTitle from "./DialogTitle.vue";
import SurveyPageTitle from "./Survey.PageTitle.vue";

export default {
  components: { DialogTitle, SurveyPageTitle },
  data: () => ({
    innerValue: null,
    openEditor: false,
    page: 0
  }),
  props: {
    value: {
      type: Object
    },
    pageIndex: {
      type: Number
    },
    pageCount: {
      type: Number
    },
    locked: Boolean
  },
  watch: {
    value(val) {
      if (this.innerValue != val)
        this.innerValue = JSON.parse(JSON.stringify(val));
    },
    openEditor(val) {
      if (val) {
        this.innerValue = JSON.parse(JSON.stringify(this.value));
      }
    }
  },
  methods: {
    edit() {
      this.openEditor = true;
    },
    onSubmit() {
      this.$emit("input", this.innerValue);
      this.openEditor = false;
    }
  },
  mounted() {
    if (this.value) this.innerValue = JSON.parse(JSON.stringify(this.value));
  }
};
</script>
